import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { userLoginSuccess } from "../_redux/actions/accountActions";
import {
  Container,
  Grid,
  Step,
  StepLabel,
  Stepper,
  styled,
  Typography,
} from "@mui/material";
import { Person, Home, Lock } from "@mui/icons-material";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BigButton } from "./Components/Buttons";

import LanguageSelector from "../_components/LanguageSelector";
import { Policies } from "../_components/Policies";
import { Copyright } from "../_components/Copyright";
import GoogleReCaptchaText from "./GoogleReCaptchaText";

import Password from "./Password";
import Address from "./Address";
import PersonalInformation from "./PersonalInformation";

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient( 136deg, rgb(72,113,34) 0%, rgb(118,188,33) 50%, rgb(84,195,97) 100%)",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient( 136deg, rgb(72,113,34) 0%, rgb(118,188,33) 50%, rgb(84,195,97) 100%)",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundImage:
      "linear-gradient( 136deg, rgb(72,113,34) 0%, rgb(118,188,33) 50%, rgb(84,195,97) 100%)",

    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundImage:
      "linear-gradient( 136deg, rgb(72,113,34) 0%, rgb(118,188,33) 50%, rgb(84,195,97) 100%)",
  }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <Person />,
    2: <Home />,
    3: <Lock />,
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

const Register = ({ history, userLoginSuccess }) => {
  const { t } = useTranslation();
  document.title = `LifeSafer - ${t("registration.sectionTitle")}`;
  const [activeStep, setActiveStep] = useState(0);
  const [userInfo, setUserInfo] = useState({});
  const getSteps = () => {
    return [
      t("registration.personalInformationStep"),
      t("registration.addressStep"),
      t("registration.passwordStep"),
    ];
  };
  const steps = getSteps();
  const handleNext = () => {
    setActiveStep((currentStep) => currentStep + 1);
  };
  const getStepContent = (stepIndex) => {
    switch (stepIndex) {
      case 0:
        return (
          <PersonalInformation
            handleNext={handleNext}
            UpdateUserInfo={UpdateUserInfo}
            userInfo={userInfo}
          />
        );
      case 1:
        return (
          <Address
            handleNext={handleNext}
            UpdateUserInfo={UpdateUserInfo}
            userInfo={userInfo}
          />
        );
      case 2:
        return (
          <Password
            handleNext={handleNext}
            UpdateUserInfo={UpdateUserInfo}
            userInfo={userInfo}
          />
        );
      default:
        return "Unknown stepIndex";
    }
  };
  const UpdateUserInfo = (update) => {
    setUserInfo({ ...userInfo, ...update });
  };
  useEffect(() => {
    if (activeStep === steps.length) {
      setTimeout(() => {
        userLoginSuccess();
        history.push({ pathname: "/" });
      }, 3500);
    }
  }, [activeStep]);
  return (
    <Container>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item sx={{ marginLeft: "350px" }}>
          <LanguageSelector />
        </Grid>
        <Grid item>
          <img src={"./src/_images/LogoLimited.png"} alt="LifeSafer" />
          <Typography variant="h6" sx={{ padding: "1rem" }}>
            {t("account.headerSlogan")}
          </Typography>
        </Grid>
        <Grid item sx={{ width: "100%" }}>
          <Stepper
            alternativeLabel
            activeStep={activeStep}
            connector={<ColorlibConnector />}
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel StepIconComponent={ColorlibStepIcon}>
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
          <div>
            {activeStep === steps.length ? (
              <div style={{ textAlign: "center", marginTop: "2em" }}>
                <Typography variant="subtitle1">
                  {t("registration.registrationComplete.0")}
                </Typography>
                <Typography variant="subtitle1">
                  {t("registration.registrationComplete.1")}
                </Typography>
                <Typography variant="subtitle1">
                  {t("registration.registrationComplete.2")}
                </Typography>
              </div>
            ) : (
              <div>
                <div style={{ marginTop: "2em", marginBottom: "1em" }}>
                  {getStepContent(activeStep)}
                </div>
              </div>
            )}
          </div>
        </Grid>
        <Grid item sx={{ padding: "1rem" }}>
          <RouterLink to="/" style={{ textDecoration: "none" }}>
            <BigButton variant="contained" color="secondary">
              {t("registration.backToSignIn")}
            </BigButton>
          </RouterLink>
        </Grid>
        <Grid item>
          <Policies />
          <Copyright />
          <GoogleReCaptchaText />
        </Grid>
      </Grid>
    </Container>
  );
};
Register.propTypes = {
  history: PropTypes.object,
  userLoginSuccess: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    userLoginSuccess: state.userLoginSuccess,
  };
}
const mapDispatchToProps = {
  userLoginSuccess,
};
export default connect(mapStateToProps, mapDispatchToProps)(Register);
